import React from 'react';
import { PlmEventResponseDetailForm } from './plmEventResponse-detail-form';

export const PlmEventResponseAdd: React.FC = () => {
  return <PlmEventResponseDetailForm />;
};
